import {IntermediatePart} from "../../intermediatePart";
import store from "../../../../../store";
import {getFeatureIsLocked} from "../../../../../misc/helpers";

export default class Range extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'range';
    this.partName = 'Range';
    this.translateId = "visualizer.kitchen.appliance.range";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Range());
    // const rangeType = dbFeature.metaData && dbFeature.metaData["RangeType"];
    // if (!rangeType) {
    //   dbFeature.metaData["RangeType"] = ["ALL"];
    // }
  }

  handleClick(ignoreLocked = false, clickFrom = "") {
    const {isEncore} = store.getState().fabricatorState;
    const applianceParent = this.getParent().getParent();
    const featureIsLocked = getFeatureIsLocked(this, ignoreLocked);

    if (isEncore) {
      if (ignoreLocked || !featureIsLocked) {
        if (applianceParent.layout.type === 6) {
          if (applianceParent.hood && !applianceParent.hood.disabled) {
            applianceParent.hood.disabled = true;
          }
          if (applianceParent.oven && !applianceParent.oven.disabled) {
            applianceParent.oven.disabled = true;
          }
          if (applianceParent.microwave && applianceParent.microwave.disabled) {
            applianceParent.microwave.disabled = false;
          }
        }
      }
    }
    if (ignoreLocked || !featureIsLocked) {
      const currentHoodWidth = applianceParent.hood.activeFeature.metaData["Width"];
      const newWidth = this.metaData["Width"];
      if (newWidth && (!currentHoodWidth || (newWidth[0] !== currentHoodWidth[0]))) {
        const currentHoodNavItems = applianceParent.hood.navigationSubItems();
        const sameWidth = currentHoodNavItems.filter(navItem => {
          if (!navItem.part.metaData["Width"]) {
            return false
          }
          if (newWidth[0] === "24") {
            return navItem.part.metaData["Width"][0] === newWidth[0] || navItem.part.metaData["Width"][0] === "30"
          }
          return navItem.part.metaData["Width"][0] === newWidth[0]
        });
        console.log("newWidth", newWidth[0]);
        console.log("sameWidth", sameWidth);
        if (sameWidth.length) { // here we can filter by the same name, color etc.
          applianceParent.hood.activeFeature = sameWidth[0].part;
        }
      }
      if (applianceParent && applianceParent.stove && !applianceParent.stove.disabled) {
        applianceParent.stove.disabled = true;
      }
    }
    return super.handleClick(ignoreLocked, clickFrom);
  }

  disabledClick() {
    const applianceParent = this.getParent();
    if ((applianceParent.layout.type === 6) && !this.disabled && applianceParent.stovetop
      && !applianceParent.stovetop.disabled) {
      applianceParent.stovetop.disabled = true;
    }
    if (applianceParent.hood) {
      applianceParent.hood.disabled = this.disabled;
    }
    if (!this.disabled && applianceParent.stove && !applianceParent.stove.disabled) {
      applianceParent.stove.disabled = true;
    }
  }

}
